document.addEventListener('giftship.loaded', () => {
  // giftship要素
  const gsContainer = document.getElementById('gsAppContainer')
  const optionWrappers = gsContainer.querySelectorAll('.gs__product-option')

  // 刺繍位置画像
  const embroideryPositionImage = document.querySelector('.product-gallery__thumbnail[data-image-type="刺繍位置"]')
  // フォント見本画像
  const fontSampleImage = document.querySelector('.product-gallery__thumbnail[data-image-type="フォント見本"]')
  // 色見本画像
  const colorSampleImage = document.querySelector('.product-gallery__thumbnail[data-image-type="色見本"]')

  if (gsContainer && optionWrappers.length) {
    optionWrappers.forEach((wrapper) => {
      const trigger = wrapper.querySelector('select') || wrapper.querySelector('input[type="radio"]') || null
      if (!trigger) return
      trigger.addEventListener('change', (e) => {
        console.log(e.target)
        const optName = e.target.getAttribute('name')
        if (optName === 'properties[刺繍位置]' && embroideryPositionImage) {
          embroideryPositionImage.click()
        } else if (optName === 'properties[フォント]' && fontSampleImage) {
          fontSampleImage.click()
        } else if (optName === 'properties[カラー（糸色）]' && colorSampleImage) {
          colorSampleImage.click()
        }
      })
    })
  }
})
